import { uniqueId } from 'lodash';
import { useRef } from 'react';

/**
 * @template T
 * Simple hook to initialize a ref with a value using a factory function that is only called once.
 *
 * @param {() => T} factoryFn
 * @returns {T}
 */
export default function useSingletonValue(factoryFn) {
    const initializedRef = useRef(false);
    const valueRef = useRef();

    if (initializedRef.current === false) {
        valueRef.current = factoryFn();
        initializedRef.current = true;
    }

    return valueRef.current;
}

/**
 * Returns a unique, but consistent, id per component
 * @param {string} [prefix] A prefix for the ID, for example: `'my-id-'`.
 * @returns {string}
 */
export function useUniqueId(prefix) {
    return useSingletonValue(() => uniqueId(prefix));
}
